<template>
  <div>
    <div class="hidden-md-and-down">
      <el-table
        :data="creditNotes"
        stripe
        :cell-style="{padding:'2px'}"
        ref="multipleTable"
        v-loading="creditNotesLoading">
        <div slot="empty">
          <span>{{$t('credit_notes.noCreditNote')}}</span>
        </div>
        <el-table-column
          :label="$t('credit_notes.creditNoteNumber')" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <el-link @click="openCreditNote(scope.row.id)">{{scope.row.cr_number}}</el-link>
            </template>
        </el-table-column>
        <el-table-column
          :label="$t('credit_notes.name')"
          :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <el-link @click="openClient(scope.row.customer)">{{customerName(scope.row.customer)}}</el-link>
            </template>
        </el-table-column>
        <el-table-column
          :label="$t('credit_notes.date')" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{_moment(scope.row.date)}}</span>
            </template>
        </el-table-column>
        <el-table-column
          :label="$t('credit_notes.invoice')" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <el-link @click="openInvoice(scope.row.invoice)" v-if="scope.row.invoice">{{scope.row.invoice.inv_number}}</el-link>
            </template>
        </el-table-column>
        <el-table-column
          :label="$t('credit_notes.status')" width="150">
         <template slot-scope="scope">
             <el-tag style="margin-right:5px;" v-if="scope.row.status">{{$t('credit_notes.statuses.'+scope.row.status.code)}}</el-tag>
         </template>
       </el-table-column>
       <el-table-column
        :label="$t('credit_notes.total')" width="150" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span >{{$n(scope.row.total, 'currency')}}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
    <!-- <div class="hidden-lg-and-up">
      <div v-for="inv in invoices" :key="inv.id">
        <InvoiceTile @click="openInvoice(inv.id)" :customer="inv.customer" :inv_number="inv.inv_number" :reference="inv.reference" :date="inv.date" :total="inv.total" :status="inv.status" :files="inv.files" :currency="inv.currency"></InvoiceTile>
        <el-divider />
      </div>
    </div> -->
  </div>
</template>
<script>
import moment from 'moment-timezone'
import { mapActions, mapState, mapGetters } from 'vuex';
import creditNoteAPI from '@/services/API/creditNote';
// import InvoiceTile from '@/components/invoice/Invoice-tile'

export default {
  name: 'credit-note-table',
	props: {
    creditNotesSource : {
      type : Array
    },
    customerId : {
      type : String,
      default : null
    },
    sortable : {
      type : Boolean,
      default : false
    },
    filter : {
      type : Object,
      default : null
    }
	},
  data() {
    return {
      creditNotesFetched : [],
      creditNotesLoading : false,
    };
  },components: {
    // PaymentInvoiceCard,
    // AddPaymentsDialog,
    // InvoiceTile
  },
  watch : {
    customerId : function(newVal, oldVal){
      if(newVal!=oldVal){
          this.fetchCreditNotes();
      }
    }
  },
	methods: {
    openCreditNote(creditNoteId){
      var index='/credit-notes/'+creditNoteId;
      this.$router.push(index);
    },
    openInvoice(invoiceId){
      var index='/invoices/'+invoiceId;
      this.$router.push(index);
    },
    fetchCreditNotes(){
      let params = {};
      params.customerId = this.customerId?this.customerId:undefined;
      if(this.filter!=null && this.filter.statusCode!=null){
        params.statusCode = this.filter.statusCode;
      }
      params.paging='no';
      this.creditNotesLoading = true;
      creditNoteAPI.fetchCreditNotes(params)
        .then(creditNotes=>{
          // console.log(invoices);
          this.creditNotesFetched= creditNotes;
          this.creditNotesLoading = false;
        })
    },
    _moment(datetime, format='L'){
      return moment(datetime).format(format);
    }

	},
	computed: {
    creditNotes(){
      return this.creditNoteSource!=null ? this.creditNoteSrouce : this.creditNotesFetched;
    },
    ...mapGetters('customers',['customerName'])
	},
  mounted(){
    this.fetchCreditNotes();
  }
}
</script>
<style lang="scss" scoped>




</style>
